import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trophy, Ear, MessageCircle, Flame, Lock } from "lucide-react";

const ICONS = { trophy: Trophy, ear: Ear, message: MessageCircle };

export const StreaksCard = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/me/streaks").then(r => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return null;

  return (
    <div data-testid="streaks-card" className="rounded-3xl border border-white/10 bg-[#0F1117] p-6 md:p-8 mb-12">
      <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.24em] text-rose-400 mb-3">
        <Flame className="h-3 w-3" /> Reader streaks
      </div>
      <div className="grid grid-cols-3 gap-4 mb-6">
        <Stat label="Vote streak" value={`${data.vote_streak}d`} tone="rose" />
        <Stat label="Listens" value={data.listen_count} tone="amber" />
        <Stat label="Characters met" value={data.chat_characters} tone="sky" />
      </div>
      <div className="grid sm:grid-cols-3 gap-3">
        {data.badges.map(b => {
          const Icon = ICONS[b.icon] || Trophy;
          return (
            <div key={b.id} data-testid={`badge-${b.id}`} className={`relative rounded-2xl border p-4 ${b.unlocked ? "border-amber-500/40 bg-amber-500/8" : "border-white/8 bg-[#07080A] opacity-70"}`}>
              <div className="flex items-center justify-between mb-2">
                <Icon className={`h-5 w-5 ${b.unlocked ? "text-amber-300" : "text-slate-600"}`} />
                {!b.unlocked && <Lock className="h-3 w-3 text-slate-600" />}
              </div>
              <div className="font-serif text-base font-semibold text-slate-100">{b.name}</div>
              <div className="text-[11px] text-slate-500 mt-1">{b.desc}</div>
              {b.unlocked && <div className="mt-2 font-mono text-[9px] uppercase tracking-widest text-amber-400">Unlocked</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const Stat = ({ label, value, tone }) => {
  const tones = { amber: "text-amber-300", sky: "text-sky-300", rose: "text-rose-300" };
  return (
    <div className="rounded-xl bg-[#07080A] border border-white/8 p-4">
      <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mb-1">{label}</div>
      <div className={`font-serif text-3xl font-bold ${tones[tone]}`}>{value}</div>
    </div>
  );
};
